import { wait } from '@cgs/shared';
import { DATA_ACCESS_SERVICE_TOKEN } from '@cgs/data-access';
import { MachineStateDto } from '@cgs/provider-cgs';
import { TrifectaDemoPlayResponseDto } from '../../../models/trifecta-dto';
import { TrifectaGameHook } from './trifecta-game-hook';
import { TrifectaDemoDataAccessService } from '../services/trifecta-demo-data-access.service';
import { TrifectaReplayDataAccessService } from '../services/trifecta-replay-data-access.service';

export class TrifectaReplayGameHook extends TrifectaGameHook {
  private readonly dataAccessService: TrifectaReplayDataAccessService;

  constructor(...args: ConstructorParameters<typeof TrifectaGameHook>) {
    super(...args);

    this.dataAccessService =
      this.container.resolve<TrifectaDemoDataAccessService>(DATA_ACCESS_SERVICE_TOKEN);
  }

  protected async handlePlay(
    response: TrifectaDemoPlayResponseDto | Error,
    onSuccess: () => void,
    onError: (err: string) => void
  ): Promise<void> {
    if (response instanceof Error) {
      return onError(response.message);
    }

    this.gameStateMachine.doSpin();
    await wait(100);
    this.dataAccessService.nextSpins(response.spins);

    this.checkAutoplayConditions(response.spins[0]);

    await this.roundFinished;
    await this.trifectaSDKAdapter.acknowledgeSpins();
    await this.waitRoundEnd(response.spins[response.spins.length - 1]);

    onSuccess();
  }

  protected waitRoundEnd(_spin: MachineStateDto): Promise<void> {
    return wait(1000);
  }
}
